module.exports = __webpack_public_path__ + "media/images/sta_interventions_app_icon-3fc3bbfbf45059a1f713ad414952c472.png";